/**
 * 仕込みの取り込み(#250)の失敗を、画面の見出しの直下にアラートとして出す。
 *
 * 失敗の理由・選択肢のボタン・作り方の入力・「回答を本文に反映」まで、この枠の中で完結させる。
 * 以前は一覧に「失敗(再実行が要ります)」とだけ出し、選択肢はレビュー画面の奥の仕込み一覧に
 * あったため、何をすればよいか分からなかった(2026-09-30 柴田の指示で、アラートと操作を同じ箇所に置く)。
 */
import type { EditDoc } from "../lib/manual-edits";
import type { JobDoc } from "../lib/types";
import { PrepDocImport } from "./PrepDocImport";

interface Props {
  dishId: string;
  /** 取り込みに失敗した仕込みの名前(dish.failedJob.ingredient) */
  ingredient: string;
  /** 品目のジョブ(作成の新しい順) */
  jobs: (JobDoc & { id: string })[];
  recipeDocs: string[];
  edits: Record<string, EditDoc>;
  busy: boolean;
}

export function PrepFailureAlert({ dishId, ingredient, jobs, recipeDocs, edits, busy }: Props) {
  // この仕込みの直近の取り込み・扱いの切り替え(切り替えた後に古い失敗を出し続けない)
  const j = jobs.find((x) => (x.type === "prep-doc" || x.type === "link-prep") && x.ingredient === ingredient);
  const job = j
    ? { type: j.type, status: j.status, error: j.error, errorKind: j.errorKind ?? null, docPath: j.docPath ?? null }
    : null;
  return (
    <PrepDocImport
      dishId={dishId}
      name={ingredient}
      recipeDocs={recipeDocs}
      job={job}
      busy={busy}
      edits={edits}
      alert
    />
  );
}
